/**
 * The registry resource rules add themselves to on import. A **Resource rule** checks one resource
 * section, a `[sub_resource]` or a `.tres` body, for a condition Godot reports when it loads that
 * resource, whatever holds it. A node-anchored `LintRule` misses a resource no node in the file
 * holds, and reports a shared one once per holder.
 */
import * as logger from '../logger';
class ResourceRuleRegistry {
    rules = new Map();
    register(rule) {
        if (this.rules.has(rule.meta.name)) {
            logger.warn(`Resource rule "${rule.meta.name}" is already registered. Overwriting.`);
        }
        this.rules.set(rule.meta.name, rule);
    }
    getRules() {
        return Array.from(this.rules.values());
    }
    getRulesForResourceType(resourceType) {
        return this.getRules().filter((rule) => rule.meta.resourceType === resourceType);
    }
}
export const resourceRuleRegistry = new ResourceRuleRegistry();
//# sourceMappingURL=ResourceRuleRegistry.js.map